// This is being used for the shared secret form in the shared secrets index page
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "individualRadio", 
    "bulkRadio", 
    "individualFields", 
    "bulkFields", 
    "questionHint", 
    "answerHint",
    "form",
    "recipientEmail",
    "secretContent", 
    "excelFile"
  ]

  static values = {
    individualPath: String,
    bulkPath: String
  }

  connect() {
    this.toggleFormFields()
  }

  toggleFormFields() {
    if (!this.hasIndividualRadioTarget || !this.hasBulkRadioTarget) {
      return
    }

    if (this.individualRadioTarget.checked) {
      this.showIndividualFields()
    } else if (this.bulkRadioTarget.checked) {
      this.showBulkFields()
    }
  }

  showIndividualFields() {
    // Show individual fields, hide bulk fields
    if (this.hasIndividualFieldsTarget) {
      this.individualFieldsTarget.classList.remove('hidden')
    }
    if (this.hasBulkFieldsTarget) {
      this.bulkFieldsTarget.classList.add('hidden')
    }
    if (this.hasQuestionHintTarget) {
      this.questionHintTarget.classList.add('hidden')
    }
    if (this.hasAnswerHintTarget) {
      this.answerHintTarget.classList.add('hidden')
    }

    // Update form action for individual submission
    if (this.hasFormTarget) {
      this.formTarget.action = this.individualPathValue
    }

    // Make individual fields required
    if (this.hasRecipientEmailTarget) {
      this.recipientEmailTarget.required = true
    }
    if (this.hasSecretContentTarget) {
      this.secretContentTarget.required = true
    }
    if (this.hasExcelFileTarget) {
      this.excelFileTarget.required = false
    }
  }

  showBulkFields() {
    // Show bulk fields, hide individual fields
    if (this.hasIndividualFieldsTarget) {
      this.individualFieldsTarget.classList.add('hidden')
    }
    if (this.hasBulkFieldsTarget) {
      this.bulkFieldsTarget.classList.remove('hidden')
    }
    if (this.hasQuestionHintTarget) {
      this.questionHintTarget.classList.remove('hidden')
    }
    if (this.hasAnswerHintTarget) {
      this.answerHintTarget.classList.remove('hidden')
    }

    // Update form action for bulk submission
    if (this.hasFormTarget) {
      this.formTarget.action = this.bulkPathValue
    }

    // Make bulk fields required
    if (this.hasRecipientEmailTarget) {
      this.recipientEmailTarget.required = false
    }
    if (this.hasSecretContentTarget) {
      this.secretContentTarget.required = false
    }
    if (this.hasExcelFileTarget) {
      this.excelFileTarget.required = true
    }
  }
}